/** Математика осей и разметки, общая для всех графиков. */

/**
 * Округлённые «красивые» деления оси Y: от min(0, минимум) до максимума данных.
 * Последний тик всегда >= max, иначе линия вышла бы за верхнюю сетку панели.
 */
export function niceTicks(rawMin: number, rawMax: number, target = 4): number[] {
	const min = Math.min(0, rawMin);
	const max = rawMax <= min ? min + 1 : rawMax;
	const span = max - min;
	const rawStep = span / target;
	const mag = Math.pow(10, Math.floor(Math.log10(rawStep)));
	let step = mag;
	for (const m of [1, 2, 2.5, 5, 10]) {
		if (mag * m >= rawStep) {
			step = mag * m;
			break;
		}
	}
	const ticks: number[] = [];
	for (let v = Math.floor(min / step) * step; ; v += step) {
		// step может быть дробным (2.5) — гасим накопление ошибки округлением
		ticks.push(Math.round(v * 1000) / 1000);
		if (v >= max) break;
	}
	return ticks;
}

/**
 * Индексы подписей оси X: равномерно ~maxLabels штук, последняя точка всегда подписана.
 */
export function xTickIndexes(n: number, maxLabels = 7): number[] {
	if (n === 0) return [];
	const step = Math.max(1, Math.ceil(n / maxLabels));
	const idxs: number[] = [];
	for (let i = 0; i < n; i += step) idxs.push(i);
	if (idxs[idxs.length - 1] !== n - 1) {
		// Последняя подпись вплотную к предыдущей — предыдущую убираем, иначе наложатся
		if (n - 1 - idxs[idxs.length - 1] < step / 2) idxs.pop();
		idxs.push(n - 1);
	}
	return idxs;
}

/** «2026-07-04» → «04.07» — короткая подпись дня на оси X */
export const fmtDayLabel = (d: string) => `${d.slice(8, 10)}.${d.slice(5, 7)}`;

/** «2026-07-04» → «04.07.2026» — полная дата для тултипов */
export const fmtDayFull = (d: string) => `${d.slice(8, 10)}.${d.slice(5, 7)}.${d.slice(0, 4)}`;
